const getFullName = {
  methods: {
    getFullName(user) {
      return `${user.firstName} ${user.lastName}`;
    },
  },
};

export default getFullName;



// WEBPACK FOOTER //
// ./src/mixins/getFullName.js